module.exports = __webpack_public_path__ + "img/triell-3.3fcc7573.png";